function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.8,
  d: "M37.5 0C16.79 0 0 16.79 0 37.5S16.79 75 37.5 75 75 58.21 75 37.5 58.21 0 37.5 0zm4.315 49.956c-3.469 0-6.731-1.875-7.848-4.005 0 0-1.866 7.4-2.258 8.828-1.391 5.05-5.483 10.1-5.802 10.513-.221.287-.712.198-.762-.184-.087-.643-1.132-7.012.097-12.207l4.13-17.504s-1.023-2.051-1.023-5.083c0-4.761 2.759-8.315 6.195-8.315 2.92 0 4.33 2.194 4.33 4.823 0 2.937-1.868 7.329-2.833 11.399-.806 3.407 1.708 6.187 5.068 6.187 6.087 0 10.183-7.817 10.183-17.08 0-7.04-4.738-12.31-13.364-12.31-9.742 0-15.817 7.266-15.817 15.385 0 2.797.827 4.773 2.12 6.299.594.702.678.984.463 1.79-.156.592-.507 2.014-.656 2.577-.214.814-.872 1.104-1.61.804-4.485-1.831-6.576-6.746-6.576-12.271 0-9.125 7.695-20.067 22.958-20.067 12.264 0 20.337 8.874 20.337 18.402 0 12.604-7.007 22.019-17.332 22.019z"
});

function SvgPinterestLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestLogo);
export default __webpack_public_path__ + "static/media/pinterest-logo.c821424e.svg";
export { ForwardRef as ReactComponent };